// extracted by mini-css-extract-plugin
export default {"cover":"Cover_cover__Xcsj+","video":"Cover_video__u0Q27"};